import React from 'react';

const ContactUsIcon = () => {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width="30" height="30" viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            fill="#000000" stroke="none">
            <path d="M2368 4599 c-643 -62 -1225 -463 -1521 -1046 l-52 -103 -51 0 c-188
            0 -423 -135 -539 -310 -110 -166 -128 -258 -122 -633 4 -316 9 -344 76 -482
            116 -236 372 -395 635 -395 149 0 301 48 342 109 38 57 33 107 -25 226 -183
            376 -219 783 -106 1178 144 499 547 916 1045 1081 480 159 987 90 1408 -191
            366 -243 616 -626 699 -1068 25 -131 24 -426 -1 -560 -104 -562 -492 -1032
            -1014 -1230 -87 -33 -238 -75 -268 -75 -15 0 -26 10 -35 31 -7 18 -36 56 -65
            86 -199 204 -553 145 -670 -112 -115 -251 33 -537 305 -587 170 -32 362 67
            444 228 l25 49 88 18 c438 89 853 357 1133 730 l73 97 102 -7 c345 -21 650
            198 742 532 26 92 32 593 9 707 -32 159 -106 291 -221 397 -112 103 -298 181
            -428 181 l-52 0 -38 78 c-357 725 -1116 1148 -1918 1071z"/>
            <path d="M2426 3940 c-297 -34 -575 -173 -780 -390 -164 -175 -269 -379 -322
            -625 -21 -100 -24 -339 -5 -445 38 -218 161 -476 292 -615 l28 -30 -70 -260
            c-45 -169 -68 -270 -64 -289 8 -45 42 -92 79 -110 73 -34 90 -28 382 140 l272
            155 83 -18 c116 -25 362 -25 479 0 252 54 463 166 639 339 186 183 317 431
            362 688 19 106 16 345 -5 445 -78 365 -285 658 -597 846 -218 131 -522 197
            -773 169z m-301 -1120 c140 -68 91 -280 -66 -280 -125 0 -192 145 -112 241 50
            59 110 72 178 39z m514 -8 c66 -49 87 -120 55 -188 -46 -96 -186 -112 -250
            -29 -46 60 -45 129 3 186 51 60 134 74 192 31z m500 1 c114 -86 79 -252 -58
            -270 -104 -14 -192 81 -167 181 8 34 54 86 91 102 38 18 100 11 134 -13z"/>
            </g>
            </svg>
  );
};

export default ContactUsIcon;